import { useContainer } from '../../../hooks/useContainer';
import { ToastStateHandler, UserApi } from '../../../api';
import { useHttpPostAuthUserNoRoleCheck, useHttpPostRefreshToken } from '../authApi';
import { useNavigate } from 'react-router';
import { useTranslation } from '../../useTranslation';

const useHttpJoinOrganization = () => {
    const { t } = useTranslation('newNotifications');
    const userApi: UserApi = useContainer(UserApi);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);
    const { exec: authUser } = useHttpPostAuthUserNoRoleCheck();
    const navigate = useNavigate();
    const { refreshToken } = useHttpPostRefreshToken();

    const execJoinOrganization = (joinToken: string) => {
        const { exec, abort } = userApi.joinOrganzation({
            params: { joinToken },
            onSuccess: () => {
                const callback = {
                    onSuccess: () => {
                        authUser();
                        toastHandler.push('success', t('organization.joinOrganizationTitle'), t('organization.joinOrganizationMessage_Success'));
                        navigate('/');
                    },
                };
                refreshToken(callback);
            },
            onError: error => {
                return error;
            },
        });
        exec();
        return abort;
    };

    return { execJoinOrganization };
};

export default useHttpJoinOrganization;
